// 🧾 Installateurs — Phase 2 : helpers frontend des déductions automatiques (aperçu taxes = même règle que le backend).
import { TPS_RATE, TVQ_RATE } from './lmdsCalcul';

const r2 = (v) => Math.round((v + Number.EPSILON) * 100) / 100;

export function montantsRegle(montantSaisi, modeTaxes) {
  const m = parseFloat(montantSaisi) || 0;
  if (modeTaxes === 'taxes_incluses') {
    const avant = r2(m / (1 + TPS_RATE + TVQ_RATE));
    return { montant_avant_taxes: avant, tps: r2(avant * TPS_RATE), tvq: r2(avant * TVQ_RATE), total: r2(m) };
  }
  const tps = r2(m * TPS_RATE), tvq = r2(m * TVQ_RATE);
  return { montant_avant_taxes: r2(m), tps, tvq, total: r2(m + tps + tvq) };
}

export const LIBELLES_ETATS = {
  a_venir: 'À venir', appliquee: 'Appliquée', en_attente: 'En attente', reportee: 'Reportée', annulee: 'Annulée', desactivee: 'Désactivée',
};
export const CLASSES_ETATS = {
  a_venir: 'bg-sky-100 text-sky-800 border-sky-200', appliquee: 'bg-emerald-100 text-emerald-800 border-emerald-200',
  en_attente: 'bg-amber-100 text-amber-800 border-amber-200', reportee: 'bg-violet-100 text-violet-800 border-violet-200',
  annulee: 'bg-slate-200 text-slate-600 border-slate-300 line-through', desactivee: 'bg-slate-100 text-slate-500 border-slate-200',
};
export const LIBELLES_FREQUENCES = { unique: 'Unique', hebdomadaire: 'Hebdomadaire', aux_28_jours: 'Aux 28 jours', mensuel: 'Mensuel' };
export const LIBELLES_STATUT_REGLE = { active: 'Active', desactivee: 'Désactivée', annulee: 'Annulée' };

export const fmtArgent = (v) => new Intl.NumberFormat('fr-CA', { style: 'currency', currency: 'CAD' }).format(v || 0);
export const fmtSemaine = (s) => (s ? `sem. ${s.semaine} (${s.annee})` : '—');
